import { Message, State } from "./types"
import moment from 'moment'

const getInitialState = (): State => ({
    data: [],
    metaParams: { filters: [], itemsSort: [], searchPlaceholder: "" }
})

export const reducer: WidgetReducerType<State, Message> = (state = getInitialState(), message, ) => {    
    if (!message) {        
        return state
    }

    if (message.baseline && message.type !== 'event') {
        return state
    }

    switch (message.type) {
        case 'start':
            const init = getInitialState();
            const filters = message.events.info?.filters || []
            const itemsSort = message.events.info?.itemsSort || []
            const searchPlaceholder = message.events.info?.searchPlaceholder || "Search by title"

            return {...init, ...{metaParams: {itemsSort, filters, searchPlaceholder}}}
        case 'event': 
            return {data: message.events, metaParams: state.metaParams}

        default:
            return state
    }
}